export default __webpack_public_path__ + "31e60e07a9ca4133a42952193d0332b0.svg";